import { Toaster } from "components";

import { manualBillingConstants } from '../constants';

import { func_validation, func_serviceHandling } from 'functions';

import { promiseInstance_authorization } from './config';



export const manualBillingActions = {
	resetFirebirdService,
};

function resetFirebirdService() {
    return dispatch => {
		dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/General/ResetService')
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully reset firebird service"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to reset firebird service";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: manualBillingConstants.resetFirebirdService_request, details }; }
    function success(details) { return { type: manualBillingConstants.resetFirebirdService_success, details }; }
    function failure(error) { return { type: manualBillingConstants.resetFirebirdService_failure, error }; }
}